import { Divider as MuiDivider } from '@mui/material';
import COLORS from '../../colors';

const Divider = () => {
  return <MuiDivider flexItem sx={{ backgroundColor: COLORS.NEUTRAL_700 }} />;
};

export default Divider;
